import React from 'react';
import Avatar from '@material-ui/core/Avatar/Avatar';
import Badge from '@material-ui/core/Badge/Badge';
import { Img, Wrapper } from './Styles';
import { CountryFlagName } from '../../common/flagPath';
import { PROFILE_ICON } from '@Images';

interface InstaremAvatarProps {
  name: string | undefined;
  isNameEmpty?: boolean;
  flagCode?: string | null;
  height?: number;
  width?: number;
}

export const InstaremAvatar: React.FC<InstaremAvatarProps> = (props): React.ReactElement => {
  const { name, flagCode, isNameEmpty, height, width } = props;
  const customInitials = (name: string): string => {
    const splitName = name?.split(' ');
    if (splitName?.length > 1) {
      return (
        splitName[0]?.substring(0, 1)?.toUpperCase() +
        splitName[splitName?.length - 1]?.substring(0, 1)?.toUpperCase()
      );
    }
    return name?.substring(0, 2)?.toUpperCase();
  };
  return (
    <Wrapper height={height} width={width}>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={flagCode ? <Img src={CountryFlagName(flagCode)} alt={flagCode} /> : ''}
      >
        <Avatar>
          {!isNameEmpty ? customInitials(name || '') : <img src={PROFILE_ICON} alt="profile" />}
        </Avatar>
      </Badge>
    </Wrapper>
  );
};
